import { ukApiURL } from '@core/Environment/Variables';

import type { OptInKeys, OptInUrls } from '../Entities/OptIn.entities';

export const OPT_IN_URLS: OptInUrls = {
  uk: `${ukApiURL}/opt-in/`,
};
export const optInKeys: OptInKeys = {
  uk: 'hc_marketing_opt_in',
};
